import React from 'react';
import { Link } from 'gatsby';
import { IoIosArrowRoundForward } from 'react-icons/io';
import ImgHTML from '../../../ImgHTML';

const SingleBox = ({ image, heading, details, link, withLongText, lg }) => {
  return (
    <div className={`col-lg-4 ${withLongText ? 'my-card' : ''}`}>
      <div className={`single-ib ${lg ? 'lg' : ''}`}>
        <div className="icon">
          <ImgHTML src={image} alt={heading} />
        </div>
        <h3 className="name">
          <Link to={link}>
            <span className="heading">{heading}</span>
          </Link>
        </h3>
        <div className="content">
          <p>{details}</p>
        </div>
        {withLongText ? (
          <Link to={link} className="read-more btn btn-main">
            Explore <IoIosArrowRoundForward />
          </Link>
        ) : (
            <Link to={link} className="btn btn-main">
              Read more
          </Link>
          )}
      </div>
    </div>
  );
};

export default SingleBox;
